<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from './mixins/log';
export default {
  mixins: [log],
  data() {
    return {
      otpusk: {},
      otpuskTypes: {
       paid: "Платен отпуск",
       unpaid: "Неплатен отпуск",
       hospital: "Болничен",
       fake: "Фиктивен",
       notpresent: "Неприсъствен",
       tripovernight: "Командировка с преспиване",
       tripday: "Командировка без преспиване",
      },
    };
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  methods: {
    getOutlookUrl(o) {
      let from = new Date(o.dateFrom);
      from.setHours(8, 30, 0, 0);
      let to = new Date(o.dateTo);
      to.setHours(17, 0, 0, 0);

      let url = `https://outlook.live.com/owa/?enddt=${encodeURIComponent(
        to.toISOString()
      )}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${encodeURIComponent(
        from.toISOString()
      )}&subject=`;

      let subject = `${this.otpuskTypes[o.type]} ${o.comment ? o.comment : ''} на ${
        o.worker.name
      }`;

      url += encodeURIComponent(subject);

      window.open(url);
    },
    confirmOtpusk() {
      const url = `${process.env.VUE_APP_BASE_URI}/otpusk/${this.$route.params.id}`;
      const conf = this.$route.name === 'otpuskConfirm' ? true : false;
      this.$http
        .get(url)
        .then(result => {
          this.otpusk = result.data;

          if (this.otpusk.confirmedAt) {
            this.$snotify.error(
              `Отпускът вече е бил ${
                this.otpusk.confirmed ? 'одобрен' : 'отхвърлен'
              }.`
            );
            return;
          }

          // the server accepts the decision only from the approver
          return this.$http.put(url, { confirmed: conf }).then(() => {
            this.$snotify.success(
              `Отпускът е успешно ${
                conf
                  ? 'одобрен. След 2 секунди ще бъде отворен Outlook.'
                  : 'неодобрен.'
              }`
            );
            if (conf) {
              setTimeout(() => {
                this.getOutlookUrl(this.otpusk);
              }, 2000);
            }
            this.newLog(
              conf ? 'confirmOtpusk' : 'rejectOtpusk',
              `на ${
                this.otpusk.worker.name
              } от ${this.$options.filters.formatDate(
                this.otpusk.dateFrom
              )} до ${this.$options.filters.formatDate(
                this.otpusk.dateTo
              )} (чрез e-mail)`
            );
          });
        })
        .catch(err => {
          console.log(err);
          this.$snotify.error(
            (err.response && err.response.data.failed) || 'Нещо се обърка'
          );
        })
        .then(() => {
          this.$router.push(
            `/calendar/4?id=${this.otpusk._id}&date=${this.otpusk.dateFrom}`
          );
        });
    }
  },
  mounted() {
    this.confirmOtpusk();
  }
};
</script>

<style>
</style>